import { createReducer, on } from '@ngrx/store';
import { resetPageLoading, setPageLoading, setSidebarCollapsed, toggleSidebar } from './common.actions';
import { initialCommonState } from './common.state';

export const _commonReducer = createReducer(
  initialCommonState,
  on(setPageLoading, (state, action) => ({
    ...state,
    pageLoading: true,
  })),
  on(resetPageLoading, (state, action) => ({
    ...state,
    pageLoading: false,
  })),
  on(toggleSidebar, (state, action) => ({
    ...state,
    sidebarCollapsed: !state.sidebarCollapsed,
  })),
  on(setSidebarCollapsed, (state, action) => ({
    ...state,
    sidebarCollapsed: action.collapsed,
  })),
);

export function commonReducer(state: any, action: any) {
  return _commonReducer(state, action);
}
